import React, { useState } from "react";
import logo from "../../assets/img/logo/fs_icon26.svg";
import logoTxt from "../../assets/img/logo/fs_logo_name26.svg";
import bellNotificationIcon from "assets/img/icons/bell_notification.svg";
import { CommonImage } from "../../styledComponents/common";
import {
  TopBarContainer,
  LogoArea,
  LogoIconImg,
  LogoTextImg,
  RightArea,
  BellWrapper,
  NotifDot,
  ProfileAvatar,
  ProfileInitials,
} from "./mobileTopBarStyles";
import MobileProfilePopup from "./MobileProfilePopup";

const MobileTopBar = ({
  profile,
  organizations,
  selectedOrganization,
  selectOrganization,
  loginProfileCreatedReset,
  history,
}) => {
  const [profilePopupOpen, setProfilePopupOpen] = useState(false);

  const thumbnail =
    profile && profile.profileData && profile.profileData.thumbnail;
  const profileColor =
    profile && profile.profileData && profile.profileData.color;
  const userFullName = localStorage.getItem("user_fullName") || "";
  const initials = userFullName
    ? userFullName
        .split(" ")
        .slice(0, 2)
        .map(w => w[0])
        .join("")
        .toUpperCase()
    : "?";

  return (
    <>
      <TopBarContainer>
        {/* Logo — icon + wordmark side by side, total 143×28 */}
        <LogoArea>
          <LogoIconImg src={logo} alt="" />
          <LogoTextImg src={logoTxt} alt="FieldServicely" />
        </LogoArea>

        {/* Right cluster: bell + avatar */}
        <RightArea>
          {/* <BellWrapper>
            <CommonImage src={bellNotificationIcon} alt="" size="20px" />
            <NotifDot />
          </BellWrapper> */}

          {thumbnail ? (
            <ProfileAvatar
              src={thumbnail}
              alt={userFullName}
              onClick={() => setProfilePopupOpen(true)}
              style={{ cursor: "pointer" }}
            />
          ) : (
            <ProfileInitials
              color={profileColor}
              onClick={() => setProfilePopupOpen(true)}
              style={{ cursor: "pointer" }}
            >
              {initials}
            </ProfileInitials>
          )}
        </RightArea>
      </TopBarContainer>

      <MobileProfilePopup
        isOpen={profilePopupOpen}
        onClose={() => setProfilePopupOpen(false)}
        organizations={organizations}
        selectedOrganization={selectedOrganization}
        selectOrganization={selectOrganization}
        loginProfileCreatedReset={loginProfileCreatedReset}
        profile={profile}
        history={history}
      />
    </>
  );
};

export default MobileTopBar;
